import { makeAutoObservable, observable, action } from 'mobx'

export class ProviderActionModalStore {
  constructor() {
    makeAutoObservable(this)
  }

  @observable
  chains: {
    currentChainId?: number
    chainIdToSwitchTo?: number
  }

  @action
  setChains({ currentChainId, chainIdToSwitchTo }: { currentChainId?: number; chainIdToSwitchTo?: number }) {
    this.chains = {
      currentChainId,
      chainIdToSwitchTo
    }
  }
}

export const providerActionModalStore = new ProviderActionModalStore()
